module.exports = __webpack_public_path__ + "static/media/undraw_content_vbqo@2x.6f681cf6.png";